import React from "react";
import { Skeleton } from "@red-digital/bricks";

import styles from "./InlineLoadingSkeleton.module.scss";

export const InlineLoadingSkeleton: React.FC = () => {
  return (
    <div className={styles.inlineLoadingSkeleton}>
      <Skeleton height="1lh" width="4lh" radius="4px" />
    </div>
  );
};
